(() => {
  'use strict';

  const isImageInteraction = (event) => {
    const path = event.composedPath();
    if (path.some((node) => node instanceof HTMLImageElement)) return true;

    const target = path.find((node) => node instanceof Element);
    const toggle = target?.closest('.product__modal-opener--image .product__media-toggle');
    const image = toggle?.closest('.product__modal-opener--image')?.querySelector('.product__media img');
    if (!image) return false;

    const bounds = image.getBoundingClientRect();
    return bounds.width > 0 && bounds.height > 0 &&
      event.clientX >= bounds.left && event.clientX <= bounds.right &&
      event.clientY >= bounds.top && event.clientY <= bounds.bottom;
  };

  const discourageImageSaving = (event) => {
    if (isImageInteraction(event)) event.preventDefault();
  };

  document.addEventListener('contextmenu', discourageImageSaving, true);
  document.addEventListener('dragstart', discourageImageSaving, true);
})();
